import React from 'react'
import { BubbleLoader } from '@deal/components'
import styles from './styles.css'

interface LoaderProps {
  label?: string
}

const Loader: React.SFC<LoaderProps> = ({ label }) => {
  return (
    <div className={styles.loader}>
      <div className={styles.circle}>
        <BubbleLoader color={'#000'} className={styles.bubbleLoader} />
      </div>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  )
}

export default Loader
